// Copyright (c) Docugami, Inc. All rights reserved.
import { IconRenderer } from 'components/work_path/IconRenderer';
import { dgIconNames } from 'hooks/dgIcons';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ErrorPageSubText, ErrorPageTitleText, UserTitle } from 'components/common/Fonts';
import { emptyColor } from 'components/shell/presentation/AppStyles';
import { Telemetry } from 'telemetry/TelemetryManager';
import { TelemetryPageView } from 'telemetry/TelemetryEvents';
import { DgUnauthenticatedShell } from 'components/shell/presentation/Header';
import { useHealthQuery } from 'store/frontend/frontendSlice';

const PageContainer = styled.div`
    display: grid;
    grid-template-rows: 1fr 2fr 2fr 1fr 1fr;
    grid-row-gap: 40px;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
`;

const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    grid-row-start: 2;
`;

const TextContainer = styled.div`
    display: flex;
    grid-row-start: 3;
    flex-direction: column;
    gap: 10px;
`;

const SubTextLink = styled(UserTitle)`
    grid-row-start: 4;
    font-size: 18px;
    font-style: italic;
`;

export const ScheduledMaintenancePage = (): JSX.Element => {
    // Poll service health every 10 seconds
    const { data: isHealthy } = useHealthQuery(undefined, { pollingInterval: 10000 })

    useEffect(() => {
        if (!!isHealthy) {
            // attempt to redirect to homepage
            window.location.href = `${window.location.origin}/home/`;
        }
    }, [isHealthy])

    useEffect(() => {
        Telemetry.trackPageView(TelemetryPageView.ScheduledMaintenance);
    }, []);

    const iconWidth = Math.max(window.innerWidth * 0.2, 150);
    return (
        <DgUnauthenticatedShell>
            <PageContainer>
                <IconContainer>
                    <IconRenderer
                        source={{
                            name: dgIconNames.DgRobotLarge,
                            height: iconWidth,
                            width: iconWidth,
                            defaultColor: emptyColor
                        }}
                        width={iconWidth}
                        height={iconWidth} />
                </IconContainer>
                <TextContainer>
                    <ErrorPageTitleText>We'll be back soon</ErrorPageTitleText>
                    <ErrorPageSubText>We are doing some scheduled maintenance, we expect the site to be fully functional soon. Thanks for your patience!</ErrorPageSubText>
                </TextContainer>
                <SubTextLink>In the meantime, check out our <a href='https://help.docugami.com/home' rel='noopener noreferrer' target='_blank'>help desk</a></SubTextLink>
            </PageContainer>
        </DgUnauthenticatedShell>
    );
}
